const taxonomy = {
	name: 'taxonomy',
	label: 'Taxonomy',
	editor: {
		preview: false
	},
	files: [
		{
			name: 'taxonomy',
			label: 'Taxonomy',
			file: 'site/data/taxonomy.yaml',
			editor: {
				preview: false
			},
			i18n: false,
			fields: [
				{
					label: 'Jobs Categories', name: 'careers', widget: 'object', fields: [
						{
							label: 'categories', name: 'categories', widget: 'list', fields: [
								{label: 'Name', name: 'name', widget: 'string'},
								{label: 'Value', name: 'value', widget: 'string'}
							]
						}
					]
				},
				{
					label: 'News Categories', name: 'news', widget: 'object', fields: [
						{
							label: 'categories', name: 'categories', widget: 'list', fields: [
								{label: 'Name', name: 'name', widget: 'string'},
								{label: 'Value', name: 'value', widget: 'string'}
							]
						}
					]
				},
				{
					label: 'Tags', name: 'tags', widget: 'list', fields: [
						{label: 'Name', name: 'name', widget: 'string'},
						{label: 'Value', name: 'value', widget: 'string'}
					]
				}
			]
		}
	]
};

export default taxonomy;
